export { authConfig } from './auth';
export { ERRORS } from './errors';
export * from './api';
export * from './booking';
export * from './date';
export * from './planner';
export * from './logbook';

export const SUPPORT_EMAIL = process.env.REACT_APP_EMAIL_SUPPORT ?? 'global.accomodation@wfp.org';

export const DATE_FORMAT = {
  API: 'YYYY-MM-DD',
  API_ALT: 'DD/MM/YYYY',
  API_TIME: 'HH:mm',
  DATEPICKER: 'dd.MM.yyyy',
  DRIVE_DATE: 'YYYY-MM-DD HH:mm:ss',
  MOMENT: 'DD.MM.YYYY',
};

export const LocalStorageKeys = {
  X_USER_TOKEN: 'X-User-Token',
  USER_EMAIL: 'USER_EMAIL',
  LOCATION: 'location',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  ID_TOKEN: 'ID_TOKEN',
  EMAIL: 'email',
  EXPIRATION: 'expiration',
};

export const SessionStorageKeys = {
  AGENCIES: 'agencies',
  SELECTED_AGENCY: 'selectedAgency',
  FACILITY: 'facility',
  SELECTED_LANGUGAGE: 'selectedLang',
};
